/*
  useWithDelay is a hook that returns a function that wraps another function with a delay.
  The delay is specified in milliseconds when calling the hook.

  This is useful for example when opening and closing a hover menu to prevent it from flickering when the user moves the mouse quickly.
*/
let timeout: NodeJS.Timeout | null = null;

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function useWithDelay<T extends (...args: any[]) => void>(
  delay: number = 250,
): [(func: T) => (...args: Parameters<T>) => void, () => void] {
  const withDelay = (func: T) => {
    return (...args: Parameters<T>) => {
      if (timeout) {
        clearTimeout(timeout);
      }

      timeout = setTimeout(() => {
        func(...args);
        timeout = null;
      }, delay);
    };
  };

  const cancelEvent = () => {
    if (timeout) {
      clearTimeout(timeout);
      timeout = null;
    }
  };

  return [withDelay, cancelEvent];
}
